import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CMS_SIGNUP_BUSINESS_INTENT } from '../constants/surveyConstants';
import { isUngatedFor } from '../utils/authUtils';
import { getAiOnboardingFlowUrl, getAiOnboardingLandingPageUrl, HubletUrl } from '../utils/urls';
import { BLOG_NEW_ONBOARDING_FLOW } from '../constants/gateConstants';
import { CMS_FREE_SIGNUP } from '../constants/signupConstants';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';

const maybeGetOverrideCmsGroupKey = (baseGroupKey, auth) => {
  return auth && isUngatedFor(auth, BLOG_NEW_ONBOARDING_FLOW) ? `${baseGroupKey}-v2` : baseGroupKey;
};

const cmsExperiencesChecks = [{
  // Note: ONBU025 variant users see the same experience except with the variant groupkeys
  // The only change in these groupkeys is that the 'create contact' and 'create deal' tasks go to the corresponding wizard instead of a tour
  redirectPath: (portalId, auth) => {
    return {
      url: getAiOnboardingFlowUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      // Selects the `-v2` version of the provided taskGroup if ungated for Blog:NewOnboardingFlow.
      // Users ungated for Blog:NewOnboardingFlow will see the 'create-a-blog-post' task in place of 'create-your-blog-task'.
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard, auth)
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    searchParams: {
      'ai-onboarding': 'true'
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: getAiOnboardingFlowUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignup, auth)
    };
  },
  checks: [{
    searchParams: {
      'ai-onboarding': 'true'
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: getAiOnboardingLandingPageUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard, auth)
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    }
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: getAiOnboardingLandingPageUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignup, auth)
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    }
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard, auth)
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignup, auth)
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP
  }]
}];
export default cmsExperiencesChecks;